import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=35627587&scoped=true&"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmComponent.vue?vue&type=style&index=0&id=35627587&scoped=true&lang=scss&"
import style1 from "./ConfirmComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35627587",
  null
  
)

export default component.exports